import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'

import { getPlatform } from '@/core/native/app'

export function init() {
  if (getPlatform() !== 'ios') return

  AppTrackingTransparency.requestPermission()
}
